var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHorizontalSmaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    width: 606.7,
    height: 104.1,
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style9",
    type: "text/css"
  }, ".st0{fill:#03bde1}.st1{fill:#1750cb}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g53",
    transform: "matrix(.6398 0 0 .6398 -27.383 -5.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M357 103.1c-1.8 5.9-2.7 9.9-2.7 9.9h-.2s-1-4-2.8-9.9L341.4 71h-16.6l21.5 61.9H362L383.5 71h-16.4z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect13",
    d: "M387.4 70.9h16.5v62.2h-16.5z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m544.7 70.9-7.9 28.9c-1.3 5.1-2.8 11.6-2.8 11.6h-.2s-1.6-6.5-2.9-11.8l-8.1-28.7h-14.1l-7.8 28.7c-1.3 5.1-2.7 11.8-2.7 11.8h-.2s-1.5-6.5-2.8-11.6l-7.5-28.9h-24c6.7 3 12.7 17.5 12.7 17.6l6.2 21.2c-1.8.8-3.3 2.3-4 4.2h-23.5v.6h-.3c-1.8 4.7-5.6 7.6-12 7.6-9.3 0-14.7-5.9-15.9-15.5H472c0-22.2-10.7-37.5-30.7-37.5-18.2 0-30.7 14.3-30.7 32.7 0 18.6 11.6 33 32.3 33 15.1 0 24.7-8.3 27.7-18.5h7.5v.4c0 4.3 3.5 7.8 7.8 7.8.4 0 .7-.1 1.1-.1l2.5 8.5h14.9l8.5-30.6c1.3-5 2.9-10.8 2.9-10.8h.2s1.5 5.8 2.8 10.8l8.2 30.6h15l18.6-62.2h-15.9zm-103 11c7.5 0 12.7 5.5 13.2 13.3h-27.6c1.4-8.1 5.6-13.3 14.4-13.3zm44.1 39.9c-2.7 0-4.9-2.2-4.9-4.9s2.2-4.9 4.9-4.9 4.9 2.2 4.9 4.9-2.2 4.9-4.9 4.9z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect17",
    d: "M304.4 46.4h16.5v14.8h-16.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect19",
    d: "M304.4 70.9h16.5v62.2h-16.5z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon21",
    d: "M61.3 46.4H43.7v86.7h58.4v-14.7H61.3z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M134.5 69.2c-18.2 0-30.7 14.3-30.7 32.7 0 18.6 11.6 33 32.3 33 16 0 25.8-9.3 28.1-20.4H148c-1.8 4.7-5.6 7.6-12 7.6-9.3 0-14.7-5.9-15.9-15.5h45.1c0-22.1-10.6-37.4-30.7-37.4zm-14.1 26c1.5-8.1 5.7-13.3 14.4-13.3 7.5 0 12.7 5.5 13.2 13.3z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "M172.1 118.3h16.5V97.8c0-8.5 5.3-14.3 12.6-14.3 6.9 0 10.8 4.7 10.8 11.4v38.2h16.5V92.5c0-13.6-8.6-23.3-21.5-23.3-3.1 0-5.8.5-8.2 1.4h-4.1c-1.2-2.9-4-4.9-7.2-4.9s-6.1 2-7.2 4.9H156l-.5 2.5h10.2c4.3 4.7 6.2 14 6.5 15.5m15.2-10.2c-2.7 0-4.9-2.2-4.9-4.9s2.2-4.9 4.9-4.9 4.9 2.2 4.9 4.9-2.2 4.9-4.9 4.9z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M278.1 78.4h-.4c-3.4-5.2-8.9-9.2-17.6-9.2-15.5 0-26.6 13.5-26.6 32.9 0 20.1 10.7 32.9 26.3 32.9 8.7 0 14.9-4 18.6-9.9h.2v8.1h15.9V46.4H278v32zm-14.6 42.7c-8.5 0-13.2-7-13.2-19 0-11.5 4.6-19.5 13.7-19.5 10.5 0 14.4 8 14.4 19.9 0 11.3-5.1 18.6-14.9 18.6z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "M187.4 68.6c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "M485.8 111.9c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon33",
    d: "M188.6 118.3h-16.5v14.8h16.5z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon37",
    d: "m556.4 100-.8 2.6h8.1l.7-2.6z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon39",
    d: "M627.8 102.6h21.3l.7-2.6h-21.2z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "M605.1 93.7c-3.8 0-7 2.7-7.7 6.4h-29.8l-.8 2.5h30.6c.5 3.8 3.8 6.8 7.7 6.8 4 0 7.2-3 7.7-6.8h11.7l.8-2.5h-12.6c-.6-3.7-3.8-6.4-7.6-6.4zm-.1 12.7c-2.7 0-4.9-2.2-4.9-4.9s2.2-4.9 4.9-4.9 4.9 2.2 4.9 4.9-2.2 4.9-4.9 4.9z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "M650.4 30.9h-64.8l-6.8 22.2c1.1 0 2.1.3 3 .7l6.1-19.9h58.3L625.4 100l-.8 2.5-8.7 27.6-57.5.2 8.5-27.8.8-2.5 9.6-31.4c-1-.2-2-.5-2.9-1.1l-10 32.4-.8 2.5-9.5 30.8 63.9-.2 9.7-30.7.8-2.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "M578.5 68.8c4 0 7.2-3 7.7-6.8h11.1l.7-2.5h-11.9c-.5-2.5-2.1-4.5-4.4-5.6-.9-.4-1.9-.7-3-.7h-.4c-3.8 0-7 2.7-7.7 6.4h-23.7l-.7 2.5h24.4c.3 2.4 1.7 4.4 3.6 5.6.9.5 1.8.9 2.9 1.1.6-.1 1 0 1.4 0zm-5-7.9c0-2.7 2.2-4.9 4.9-4.9s4.9 2.2 4.9 4.9-2.2 4.9-4.9 4.9-4.9-2.1-4.9-4.9z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M578.4 65.9c2.7 0 4.9-2.2 4.9-4.9s-2.2-4.9-4.9-4.9-4.9 2.2-4.9 4.9 2.2 4.9 4.9 4.9z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "M605 96.6c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9z",
    className: "st0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontalSmaller);
export default __webpack_public_path__ + "static/media/logo-horizontal-smaller.10792550c277e8c7e7ba4045f8b8dcb4.svg";
export { ForwardRef as ReactComponent };